import { Component, output } from "@angular/core";

@Component({
  selector: "app-close-button",
  imports: [],
  template: `
    <button class="btn-icon btn-secondary" (click)="closed.emit()" aria-label="Quitter l'exercice">
      <img src="assets/icons/close.svg" alt="close button" />
    </button>
  `,
})
export class CloseButton {
  closed = output();
}
